
import { useRef, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';

const OtpModal = ({ show, onHide, handleVerifyOtpget }) => {
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const inputRefs = useRef([]);

    const handleChange = (e, index) => {
        const value = e.target.value.replace(/[^0-9]/g, '');

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            const newOtp = [...otp];
            if (otp[index]) {
                newOtp[index] = '';
                setOtp(newOtp);
            } else if (index > 0) {
                inputRefs.current[index - 1]?.focus();
                newOtp[index - 1] = '';
                setOtp(newOtp);
            }
        }
    };

    const handleVerify = () => {
        handleVerifyOtpget(otp.join(''));
    };
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className='otp-modal'
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <p style={{ color: 'green' }}> Enter OTP for XperhirePro</p>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-center gap-2 mb-3">
                    {otp.map((digit, index) => (
                        <Form.Control
                            key={index}
                            type="text"
                            maxLength={1}
                            value={digit}
                            onChange={(e) => handleChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                            className="text-center"
                            style={{
                                width: '65px',
                                height: '40px',
                                fontSize: '20px',
                                padding: '0',
                            }}
                        />
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className='btn-danger' onClick={onHide} style={{ width: '200px', height: '50px' }}>Close</Button>
                <Button
                    variant="primary"
                    onClick={handleVerify}
                    disabled={otp.some((digit) => digit === '')}
                    style={{ width: '200px', height: '50px' }}
                >
                    Verify
                </Button>
            </Modal.Footer>
        </Modal>
    )


}

export default OtpModal

